// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".demo-spin-icon-load[data-v-41ebfcad]{animation:ani-demo-spin-41ebfcad 1s linear infinite}@keyframes ani-demo-spin-41ebfcad{0%{transform:rotate(0deg)}50%{transform:rotate(180deg)}to{transform:rotate(1turn)}}", ""]);
// Exports
module.exports = exports;
